import createDefaultPanelReducer from './createDefaultPanelReducer';

const { defaultState: defaultCurrentAlertsPanelState, reducer: currentAlertsPanel } = createDefaultPanelReducer('currentAlerts');

export { defaultCurrentAlertsPanelState };

export default currentAlertsPanel;